import {createRoot} from 'react-dom/client'
import './index.scss'
import './App.scss';
import App from './App.tsx'
import './i18n';
import {Provider} from "react-redux";
import {store} from "./state/store.ts";


createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
         <App/>
    </Provider>
)